$(document).ready(function(){
  $( '.shopify-product-form' ).on( 'click', '.custom-size', function () {
    $(".custom-size-chart").show();
    $(".custom-size").addClass("custom-selected");
  });

  $( '.shopify-product-form' ).on( 'click', '.custom-not', function () {
    $(".custom-size-chart").hide();
    $(".customlable").val('');
    $(".custom-size").removeClass("custom-selected");
  });

  $('.custom-size-chart .size-form').find('.ccc').click(function(){
    var htm = $(this).find('.des').html();
    $('.defaultdes').html(htm);
  });
  
  $('.custom_Colors').click(function(){
    $('#swatch-0-chiffon-color').trigger('click');
    $('#swatch-0-satin-color').trigger('click');
    $('#swatch-0-taffeta-color').trigger('click');
    $('#swatch-0-organza-color').trigger('click');
    $('#swatch-0-charmeuse-color').trigger('click');
    $('#swatch-0-jersey-color').trigger('click');
    $('#swatch-0-satin-chiffon-color').trigger('click');
    $(".custom_Colors").removeClass('custom_color_selected');
    $(this).addClass('custom_color_selected');
    $(".custom_Colors").find('input').removeAttr('name');
    $(this).find('input').attr('name', 'properties[custom_color]')
  });

  $('.cust_swatch_element').click(function(){
    if($(this).hasClass('color')){
      $('.custom_Colors.custom_color_selected').removeClass('custom_color_selected');
      $(".custom_Colors").find('input').removeAttr('name');
    }
  });

  $('.cust_swatch_element_color').click(function(){
    if($(this).hasClass('color')){
      $('#shop-more-color').show();
      $('.shop-morecolor-link').attr('href', "/collections/"+$(this).data('url'));
    }
  });

  $(".confirm-checkbox").on('click', function() {
    var got = 'true';
   
    if ($("#bust").val() == "" ) {
    $("#bust").css('border', "1.5px solid red");
     var got = 'false'
    }
    else{
     $("#bust").css('border', "1.5px solid #f1f1f1");
    }
      
    if($("#waist").val() == ""){
      $("#waist").css('border', "1.5px solid red");
      var got = 'false'
    }
    else{
     $("#waist").css('border', "1.5px solid #f1f1f1");
    }
    
    if($("#hips").val() == "") {
      $("#hips").css('border', "1.5px solid red");
      var got = 'false'
    }
    else{
     $("#hips").css('border', "1.5px solid #f1f1f1");
    }
    
    if($("#hollow").val() == "") {
      $("#hollow").css('border', "1.5px solid red");
      var got = 'false'
    }
    else{
     $("#hollow").css('border', "1.5px solid #f1f1f1");
    }
    
    if($("#hollow2").val() == "") {
      $("#hollow2").css('border', "1.5px solid red");
      var got = 'false'
    }
    else{
     $("#hollow2").css('border', "1.5px solid #f1f1f1");
    }
    
    if($("#length").val() == "") {
      $("#length").css('border', "1.5px solid red");
      var got = 'false'
    }
    else{
       $("#length").css('border', "1.5px solid #f1f1f1");
    }
    
    if($("#confirma").is(':checked')) {
      $(".confirm").css('border', "1.5px solid #f1f1f1");
    }  
    else{
      $(".confirm").css('border', "1.5px solid red");
    }
  });

});

$(document).ready(function(){
    if ($(window).width() <= 767 ) {
      var color_count = 0;
      $('.custom_Colors_loop').each(function(i){
        color_count++;
        
        $(this).attr('data-ct-color', i);
      });
      
      if(color_count >= 8){
		$('.data_count_value_nw_swatch').text(color_count);
          $('.swatch_count_prd').click(function(){
          $('.custom_Colors_loop').css("display", "inline-block");
          $(this).hide();
          $('.hide_color_swatch').css("display", "inline-block");
        });
        $('.hide_color_swatch').click(function(){
          $('.custom_Colors_loop').css("display", "none");
      	  $(this).hide();
          $('.swatch_count_prd').css("display", "inline-block");
        });
      }
    }

    $('.close-menu-mb').click(function(){
      $('.sub-menu-mobile').removeClass('sub-menu-open');
    });
});

$(document).ready(function() {   
      $('.cust_swatch_element.color').click(function(){
        colorsizeStock($(this).attr('data-value'));
      });

     $('.cust_swatch_element.other').click(function(){
        colorsizeStockMessage($(this).attr('data-value'));
      });

      
         colorsizeStock(jQuery('.swatch_opt').val()); 

      
      function colorsizeStock(colorval){
        var reg = new RegExp(" ","g");
        var tempcolorval = colorval.replace(reg, "");
        var newColorVal = tempcolorval.replace("/", "-");
        
        jQuery('.ico-48hrs').hide();
        $('.pointer2').hide();
            $('.pointer').show();
        
        jQuery('#product-selectors-option-1 option').each(function(){
          var reg = new RegExp(" ","g");
          var sizeopt = jQuery(this).val().replace(reg, "");
          if(jQuery('#product-selectors [data-combineswatch='+newColorVal+'-'+sizeopt+']').attr('data-stock') == "true"){
            var variantId = jQuery('#product-selectors [data-combineswatch='+newColorVal+'-'+sizeopt+']').val();
            jQuery('#stock-'+sizeopt).show();
          }
        })
      }

     function colorsizeStockMessage(sizeVal){
        var reg = new RegExp(" ","g");
        var tempsizeVal = sizeVal.replace(reg, "");
        var newSizeVal = tempsizeVal.replace("/", "-");
        var colorVal = jQuery("input[name='option-0']:checked").val();
        if (typeof colorVal === "undefined") {
          colorVal = jQuery('.swatch_opt').val();
        }
        else{
          colorVal = jQuery("input[name='option-0']:checked").val();
        }
        var reg = new RegExp(" ","g");
        var tempcolorval = colorVal.replace(reg, "");
        var newColorVal = tempcolorval.replace("/", "-");
        
        if(jQuery('#product-selectors [data-combineswatch='+newColorVal+'-'+newSizeVal+']').attr('data-stock') == "true"){
          $('.pointer2').show();
          $('.pointer').hide();
          $('.pointer2 .pointer').show();
        }
        else{
          $('.pointer2').hide();
          $('.pointer').show();
        }
      }
});